module.exports = __webpack_public_path__ + "img/franz.4b879a85.png";